import * as React from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import {
  Provider,
  Flex,
  Button,
  Divider,
  Alert,
  Image,
  List,
  Avatar,
  Dropdown,
  TextArea,
  Checkbox,
  Popup,
} from "@fluentui/react-northstar";
import { ChevronStartIcon } from "@fluentui/react-icons-northstar";
import { useState, useEffect, useRef } from "react";
import { useTeams } from "msteams-react-base-component";
import copysearch from "../../../web/assets/images/copysearch.svg";
import { Year } from "../common/utils";
import Slider from "../common/slider";
import _ from "lodash";
import heic2any from "heic2any";
import {
  getEcardDetails,
  // uploadManualImageUpload,
} from "../../services/teamsbehaviour.service";
import { useSelector, useDispatch } from "react-redux";
import {
  saveBehaviorInfo,
  setCheckboxPrivate,
  saveCustomImageInfo,
  removeCopyOthersRecipient,
  setCopyManager,
  setCopyMe,
  setCopyOthersEmail,
  saveCopyOthersRecipient,
  clearCopyOthersEmail
} from "../../action/actionCreators";
import Dropzone from "react-dropzone";
import { LoaderExample } from "../common/loader";
import TextContent from "../common/Text";
import Upload from "../../../web/assets/images/upload-icon.svg";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import { pageVariants, numberWithCommas } from "../common/utils";
import { ChevronDownIcon } from "@fluentui/react-icons-northstar";
import { useTranslation } from "react-i18next";
export const AddBehaviour = (props) => {
  const [{ inTeams, theme }] = useTeams();
  const dispatch = useDispatch();
  const history = useHistory();
  const promotion = useSelector((data: any) => data.commonReducer.promotion);
  const copyothersUser = useSelector((data: any) => data.commonReducer.copyOthersRecepients);
  const state = useSelector((data: any) => data.commonReducer);
  const ONEMB = 1048576; // one mb in bytes
  const [eCardCategories, setECardCategories] = useState(
    promotion?.eCardCategory ? promotion.eCardCategory : null
  );

  const [behaviourList, setBehaviourList] = useState(
    promotion?.behaviors ? promotion.behaviors : null
  );
  const [downUpIcons, setUpDownIcon] = useState(false);
  const [seletedBehaviour, setseletedBehaviour] = useState(
    state?.behaviour?.behaviour ? state.behaviour.behaviour : ""
  );
   const [selectedEcardCategory , setseletedEcardCategory] = useState(
    state?.eCardCategory?.eCardCategory ? state.eCardCategory.eCardCategory : ""
  );
  
  const [textAreaDetails, setTextAreadetail] = useState(
    state?.behaviour?.textArea ? state.behaviour.textArea : ""
  );
  const [eCardsList, seteCardsList] = useState([]);
  const [displayECardsList, setDisplayECardsList] = useState([]);
  const [showImage, setshowBigImage] = useState(false);
  const [manager, setManager] = useState(state.copymanager ? state.copymanager : state?.promotion?.copyManagerAlways);
  const [me, setMe] = useState(state.copyme ? state.copyme : false);
  const [copyOthersEmail, setcopyOthersEmail] = useState(false);
  const [copyOthersEmailError, setCopyOthersEmailError] = useState("");
  const [selectedImage, setSelectedimage] = useState(
    _.size(state?.behaviour?.image) > 0 ? state?.behaviour?.image : {}
  );
  const [useEcard, setEcard] = useState(
    _.size(state?.behaviour?.image) > 0 || _.size(state?.manualImageInfo) > 0
      ? true
      : false
  );
  const [awards, setshowAwards] = useState(false);
  const [isPrivate, setPrivate] = useState(
    state.private ? state.private : false
  );
  const [customImageVideo, setFileNames] = useState(
    _.size(state.manualImageInfo) > 0 ? state.manualImageInfo : {}
  );
  const [loading, setLoading] = useState(false);
  const [imageValid, setImageValidator] = useState(false);
  const [filTypes, setUnSupportedfileType] = useState(false);
  const [loader, setLoader] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [findSomeValue, setFindSomeValue] = useState("");
  const [copyOthersEmailDetails, setCopyOthersEmailDetails] = useState(state.copyothersemail ? state.copyothersemail : "");
  const { t, i18n } = useTranslation();
  const copyOthersRef: any = useRef(null);
  const location = useLocation();
  const [start, setStart] = useState(false);

  const showList = () => {
    setUpDownIcon(!downUpIcons);
  };

  useEffect(() => {
    const { id } = promotion;
    const getEcard = async () => {
      const ecards = await getEcardDetails(id);
      const customImage = {
        smallImage: "",
      };
      if (ecards && ecards.data.ecards) {
        // let data = ecards.data.ecards.unshift(customImage);
        seteCardsList(ecards.data.ecards);
        setDisplayECardsList(ecards.data.ecards);
      }
      const handleScroll = () => {
        if (location?.state?.scrollDown) {
          window.addEventListener("scroll", function(){
            const secTop = copyOthersRef.current.offsetTop;
            if (window.scrollY >= secTop - 300) {
              setStart(true);
            }
          });
        }
      };
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    };
    getEcard();
  }, []);

  const listDataConversion = (data) => {
    const result = data.map((val) => {
      return {
        key: val.text,
        media: <Avatar name={val.text} />,
        header: (
          <TextContent className="bit_text_17 paxName" content={val.text} />
        ),
        content: (
          <TextContent
            className="bit_text_14 paxDetail"
            content={val.tertiaryText}
          />
        ),
        headerMedia: (
          <TextContent
            className="bit_text_14 paxDetail"
            content={
              val.budgetPoints !== undefined
                ? `${val.budgetPoints} ${t("Behavior.Points")}`
                : ""
            }
          />
        ),
      };
    });
    return result;
  };

  const EcardCategoryLists = () => {
    const uniqueCategories = eCardCategories.filter((value, index, self) => index === self.findIndex((t) => t.name === value.name));
    uniqueCategories.unshift({ id: 'All', name: `${t("Behavior.EcardCategory")}`, key: `${t("Behavior.EcardCategory")}`, sortOrder: 0 });
    const result = uniqueCategories.map((eCardCategory) => eCardCategory.name !== null &&(
      <div key={eCardCategory.name} style={{ display: "flex", alignItems: "center" }}>
        <p>{eCardCategory.name}</p>
      </div>
    ));
  
    return result;
  };
  const onEcardCategoryChange = (e, data) => {
    const { value } = data;
    if(value?.key === `${t("Behavior.EcardCategory")}`) {
      setseletedEcardCategory({id: 'All', name: `${t("Behavior.EcardCategory")}`, key: `${t("Behavior.EcardCategory")}`, sortOrder: 0});
      seteCardsList(displayECardsList.map(item => item));
    } else {
    eCardCategories.filter((val) => {
      if(`${val.name}` === `${value.key}`) {
        setseletedEcardCategory(val);
        const cloneEcards = displayECardsList.filter(({categoryType})=> categoryType === val.id);
        seteCardsList(cloneEcards);
      }
    });
  }
    
  };
  const removeCopyOthers = (val: any) => {
    dispatch(removeCopyOthersRecipient(val));
  };

  const behaviourLists = () => {
    const result = behaviourList.map((val) => {  
      return (
        <div className={`ao eh ${val?.img ? "avatar-img" : "no-avatar-img"}`}>
        < Avatar
      image = { val?.img }
      name = { val?.name }

      className = "mg-l-5p"
        />
        <p>{ val?.name }</p>
        </div>

    );
    });
    return result;
  };

  const onBehaviourChange = (e, data) => {
    const { value } = data;
    
    behaviourList.filter((val) => {
      if(`${val?.name}` === `${value?.props?.children[0]?.props.name}`) {
        
        setseletedBehaviour(val);
      }
    });
    
  };

  const onTextAreaChange = (e, data) => {
    const { value } = data;
    setTextAreadetail(value);
  };
  const onOtherEmailChange = (e, data) => {
    setCopyOthersEmailDetails(e.target.value); 
    if(!e.target.value) { 
    dispatch(clearCopyOthersEmail());
    }
  };

  const showBigImage = (e) => {
    setshowBigImage(!showImage);
    setSelectedimage(e);
    setLoader(true);
  };

  useEffect(() => {
    const timeId = setTimeout(() => {
      // After 1 seconds set the show value to false
      setLoader(false);
    }, 0);

    return () => {
      clearTimeout(timeId);
    };
  }, [loader]);

  const listingImage = (image) => {
    if (image.length > 0) {
      const result = image.map((val) => {
        return val["smallImage"] ? (
          <img
            key={val["id"]}
            src={val["smallImage"]}
            onClick={() => showBigImage(val)}
            style={{
              height: "97px",
              width: "97px",
            }}
            className="ecard-image"
          />
        ) : (
          <img
            key={val["id"]}
            src={val["smallImage"]}
            style={{
              height: "97px",
              width: "97px",
            }}
            className="ecard-image"
          />
        );
      });
      return result;
    }
  };

  const saveBehaviorInformation = () => {
    // tslint:disable: no-shadowed-variable
    const behaviourList = {
      behaviour: seletedBehaviour,
      textArea: textAreaDetails,
      image: selectedImage,
    };
    dispatch(saveBehaviorInfo(behaviourList));
  };

  const showAwards = () => {
    setshowAwards(!awards);
    saveBehaviorInformation();
  };

  const gotoReviewSubmit = () => {
    // tslint:disable: no-shadowed-variable
    if (copyOthersEmailDetails.length < 1) {
      const behaviourList = {
        behaviour: seletedBehaviour,
        textArea: textAreaDetails,
        image: selectedImage,
      };
      dispatch(saveBehaviorInfo(behaviourList));
      history.push({
        pathname: "/review",
      });
    }

    if (copyOthersEmailDetails) {
      const copyOthersEmailArr = copyOthersEmailDetails.split(",");
      const rgexEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
      let emailCheck = false;
      for (const i in copyOthersEmailArr) {
        let emailTrim = copyOthersEmailArr[i].trim();
        const emailValidation = rgexEmail.test(emailTrim);
        if (emailValidation) {
          emailCheck = true;
          setcopyOthersEmail(true);
          setCopyOthersEmailError("");
        } else {
          emailCheck = false;
          setcopyOthersEmail(false);
          setCopyOthersEmailError("Invalid Email Address. Please enter one or more email addresses separated by commas.");
        }
      }
      if (emailCheck) {
        const behaviourList = {
          behaviour: seletedBehaviour,
          textArea: textAreaDetails,
          image: selectedImage,
        };
        const emailArr = copyOthersEmailDetails.split(",");
        const unique = Array.from(new Set(emailArr));
        const result = unique.join(",");
        dispatch(setCopyOthersEmail(result));
        dispatch(saveBehaviorInfo(behaviourList));
        history.push({
          pathname: "/review",
          state: { copyEmail: emailArr }
        });
      }
    }

  };

  const goBack = () => {
    if (promotion.awardAvailable) {
      history.push({
        pathname: "/addrecipients",
      });
    } else {
      history.push({
        pathname: "/search/:token",
      });
    }
    saveBehaviorInformation();
  };

  const gotoSearchPage = () => {
    history.push({
      pathname: "/search/:token",
    });
    saveBehaviorInformation();
  };

  const onSetPrivate = (e, value) => {
    const { checked } = value;
    setPrivate(checked);
    dispatch(setCheckboxPrivate(checked));
  };

  const onSetManager = (e, value) => {
    const { checked } = value;
    setManager(checked);
    dispatch(setCopyManager(checked));
  };

  const onSetMe = (e, value) => {
    const { checked } = value;
    setMe(checked);
    dispatch(setCopyMe(checked));
  };

  const handleDrop = async (acceptedFiles) => {
    setLoading(true); 
    const formData = new FormData();
  
    if (acceptedFiles.length > 0) {
      const file = acceptedFiles[0];
      let fileType = file.type;
      const fileName = file.name;
      const fileSize = file.size;
  
    const isHeic = fileName.toLowerCase().endsWith('.heic') || fileName.toLowerCase().endsWith('.heif');
      if (isHeic) {
        fileType = 'heic';
      }
  
      if (fileType.includes("image") || isHeic) {
        if (fileSize > state.PromotionList.imageUploadSize * ONEMB) {
          setImageValidator(true);
          setLoading(false);
          return;
        }
      } else if (fileType.includes("video")) {
        if (fileSize > state.PromotionList.videoUploadSize * ONEMB) {
          setImageValidator(true);
          setLoading(false);
          return;
        }
      } else if (fileType === "image/gif") {
        if (fileSize > state.PromotionList.gifUploadSize * ONEMB) {
          setImageValidator(true);
          setLoading(false);
          return;
        }
      } else {
        setUnSupportedfileType(true); 
        setLoading(false);
        return;
      }
  
      if (isHeic) {
        try {
          const convertedBlob = await heic2any({
            blob: file,
            toType: "image/jpeg",
          }) as Blob; 
          
    
          const baseFileName = fileName.substring(0, fileName.lastIndexOf('.')) || fileName;
          const newFileName = `${baseFileName}.jpg`;
    
          formData.append("uploadAnImage", convertedBlob, newFileName);
          formData.append("fileName", newFileName);
          formData.append("heicFileSize", fileSize.toString()); 
          formData.append("isHEIC", "true"); 
        } catch (error) {
          console.error("Error converting HEIC file:", error);
          setImageValidator(true);
          setLoading(false);
          return;
        }
      } else {
        formData.append("uploadAnImage", file);
      }
  
      try {
        const result = await uploadManualImageUpload(formData);
        if (result.data.success) {
          dispatch(saveCustomImageInfo(result.data));
          setFileNames(result.data);
          setEcard(true); 
        } else {
          setImageValidator(true);
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        setImageValidator(true);
      }
    } else {
      setUnSupportedfileType(true); 
    }
  
    setLoading(false);
  };
  
  
  const uploadManualImageUpload = async (formData) => {
    const host = localStorage.getItem("host");
    const context = localStorage.getItem("context");
    const appToken = localStorage.getItem("appToken");
    return await axios.post(
      `https://${host}/${context}/mobileapp/uploadEcardMedia.do`,
      formData,
      {
        headers: {
          "content-type": "application/json",
          "originated": "teams",
          "post-type": "ajax",
          "outlookauth": appToken,
        },
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent;
          const percent = Math.floor((loaded * 100) / total);
          setUploadProgress(percent);
        },
      }
    );
  };

  const dismissAlerts = () => {
    setImageValidator(false);
    setUnSupportedfileType(false);
  };
  const onFindChange = (e) => {
    let someone = e.target.value;
    setFindSomeValue(e.target.value);

  };
  const copysearchClick = () => {
    const behaviourList = {
      behaviour: seletedBehaviour,
      textArea: textAreaDetails,
      image: selectedImage,
    };
    dispatch(saveBehaviorInfo(behaviourList));
    history.push({
      pathname: "/search/:token",
      state: { copyothers: true, copySearchValue: "" }
    });
  };
  const AwardsEditSection = () => {
    return (
      <Flex space="between">
        <TextContent content={t("Behavior.Awards")} weight="regular" />
        <Flex gap="gap.smaller">
          <Button size="medium" content={t("Behavior.Edit")} onClick={goBack} />
        </Flex>
      </Flex>
    );
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={pageVariants}
      className={showImage ? "selectedImage" : ""}
    >
      <Provider
        theme={theme}
        className="behaviourProvider recognitionPage appProvider mg-top-2rem"
        onClick={dismissAlerts}
      >
        {!showImage ? (
          <div>
            <Divider />
            <div className="recepientsDropdown">
              <Flex vAlign="start" gap="gap.small">
                <Popup
                  open={downUpIcons}
                  onOpenChange={showList}
                  trigger={
                    <Button
                      secondary
                      title={
                        state?.recepients?.length === 1
                          ? `${t("Behavior.Recipient")}`
                          : `${t("Behavior.Recipients")}`
                      }
                      content={
                        state?.recepients?.length === 1
                          ? `${t("Behavior.Recipient")}`
                          : `${t("Behavior.Recipients")}`
                      }
                      icon={<ChevronDownIcon xSpacing="after" />}
                      iconPosition="after"
                      className="bs-none bd-none"
                    />
                  }
                  content={
                    <>
                      <Flex space="between">
                        <TextContent
                          content={
                            state?.recepients?.length === 1
                              ? `${state?.recepients?.length} ${t(
                                "Participants.Recipient"
                              )}`
                              : `${state?.recepients?.length} ${t(
                                "Participants.Recipients"
                              )}`
                          }
                          weight="regular"
                        />
                        <Flex gap="gap.smaller">
                          <Button
                            size="medium"
                            content={t("Behavior.Edit")}
                            onClick={gotoSearchPage}
                          />
                        </Flex>
                      </Flex>
                      <List
                        items={
                          promotion.awardAvailable
                            ? listDataConversion(state.singleMultiUserPoints)
                            : listDataConversion(state.recepients)
                        }
                        styles={{ width: "100%" }}
                      />
                    </>
                  }
                  position="below"
                  align="center"
                  className="bd-none bs-none mg-l-5 mg-r-5"
                />
                {promotion.awardAvailable && (
                  <Popup
                    open={awards}
                    onOpenChange={showAwards}
                    trigger={
                      <Button
                        title={t("Behavior.Awards")}
                        content={t("Behavior.Awards")}
                        iconPosition="after"
                        secondary
                        className="bs-none bd-none"
                        icon={<ChevronDownIcon xSpacing="after" />}
                      />
                    }
                    content={
                      awards &&
                      (promotion?.awardFixed || state?.checked ? (
                        <div style={{ width: "100%" }}>
                          <AwardsEditSection />
                          {promotion?.budgetInfo != null ?
                            <Slider
                              defaultValue={state?.sum}
                              max={promotion?.budgetInfo?.currentValue}
                              custom={true}
                              customText={`${(
                                promotion?.budgetInfo?.currentValue - state?.sum
                              ).toLocaleString()} ${t(
                                "Behavior.PointsRemaining"
                              )}`}
                              title={
                                <TextContent
                                  weight="bold"
                                  content={`${state?.sum} ${t(
                                    "Behavior.PointsAwarded"
                                  )}`}
                                />
                              }
                              discretionaryText={`${state?.promotion?.name}`}
                            /> :
                            <Slider
                              defaultValue={state?.sum}
                              max={state?.sum}
                              custom={true}
                              customText={
                                <TextContent
                                  className="blue-light-1"
                                  style={{ fontSize: "14px" }}
                                  content={`${state?.promotion?.name}`}
                                />
                              }
                              title={
                                <TextContent
                                  weight="bold"
                                  style={{ fontSize: "14px" }}
                                  content={`${numberWithCommas(state?.sum)} ${t(
                                    "Review.PointsAwarded"
                                  )}`}
                                />
                              }
                            />}
                        </div>
                      ) : (
                        <div style={{ width: "100%" }}>
                          <AwardsEditSection />
                          {promotion?.budgetInfo != null ?
                            <Slider
                              defaultValue={state?.numberObj?.pointasPerHeadCount}
                              max={promotion?.budgetInfo?.currentValue}
                              custom={true}
                              customText={`${(
                                promotion?.budgetInfo?.currentValue - state?.sum
                              ).toLocaleString()} ${t(
                                "Behavior.PointsRemaining"
                              )}`}
                              title={
                                <TextContent
                                  weight="bold"
                                  content={`${state?.sum} ${t(
                                    "Behavior.PointsAwarded"
                                  )}`}
                                />
                              }
                              discretionaryText={`${state?.promotion?.name}`}
                            /> :
                            <Slider
                              defaultValue={state?.sum}
                              max={state?.sum}
                              custom={true}
                              customText={
                                <TextContent
                                  className="blue-light-1"
                                  style={{ fontSize: "14px" }}
                                  content={`${state?.promotion?.name}`}
                                />
                              }
                              title={
                                <TextContent
                                  weight="bold"
                                  style={{ fontSize: "14px" }}
                                  content={`${numberWithCommas(state?.sum)} ${t(
                                    "Review.PointsAwarded"
                                  )}`}
                                />
                              }
                            />}
                        </div>
                      ))
                    }
                    trapFocus
                    position="below"
                    align="center"
                    className="bd-none bs-none mg-l-5 mg-r-5"
                  />
                )}
              </Flex>
            </div>
            <Divider className="dropdownSeparator" />
            <div className="mg-l-5 mg-r-5 ">
              {state?.promotion?.behaviors &&
                state?.promotion?.behaviors?.length > 0 && (
                  <div>
                    <div className="behaviour_sectionrow">
                      <TextContent
                        className="bit_text_18 bit_text_bold"
                        content={`${t("Behavior.Behavior")} ${state?.promotion?.behaviorRequired
                            ? ""
                            : "(" + t("Behavior.Optional") + ")"
                          }`}
                      />
                    </div>
                    <Flex vAlign="start" gap="gap.medium">
                    <div className={`relative-dropdown ${seletedBehaviour?.img ? "behavior-avatar-img" : "behavior-no-avatar-img"}`}>
                        
                        <div
                          className={
                            seletedBehaviour ? "absolute-dropdown selected" : ""
                          }
                        >

                        {seletedBehaviour && (
                        <div className="behavior-avatar-container ao eh">
                          < Avatar
                            image={seletedBehaviour?.img}
                            name={seletedBehaviour?.name}

                            className="mg-l-5p"
                          />
                        </div>
                        )}
                        
                          <Dropdown
                            items={behaviourLists()}
                            placeholder={t("Behavior.AddBehavior")}
                            onChange={(e, data) => onBehaviourChange(e, data)}
                            className={seletedBehaviour?.img ? "behavior-avatar-img" : "behavior-no-avatar-img"}
                            value={
                              seletedBehaviour
                                ? seletedBehaviour?.name
                                : state?.behaviour?.behaviour
                            }
                          />
                        </div>
                      </div>
                    </Flex>
                  </div>
                )}
              <div>
                <div className="behaviour_sectionrow">
                  <TextContent
                    className="bit_text_18 bit_text_bold"
                    content={t("Behavior.Message")}
                  />
                </div>
                <TextArea
                  fluid
                  placeholder={t("Behavior.Add Message")}
                  maxLength={2000}
                  onChange={(e, data) => onTextAreaChange(e, data)}
                  value={textAreaDetails}
                  style={{ height: "100px" }}
                />
                <div className="text-area-realtive">
                  <div className="text-area-absolute">
                    <TextContent
                      disabled
                      content={
                        textAreaDetails?.length > 0
                          ? textAreaDetails?.length + "/ 2000"
                          : "0 / 2000"
                      }
                    />
                  </div>
                </div>
              </div>
              <div>
                <Checkbox
                  label={
                    <TextContent
                      content={t("Behavior.Private")}
                      weight="semibold"
                    />
                  }
                  onClick={onSetPrivate}
                  checked={isPrivate}
                />
              </div>
              
              {state.promotion.ecardActive && (
                <div>
              <div className="behaviour_sectionrow">
                
                  <TextContent
                    className="bit_text_18 bit_text_bold"
                    content={`${t(
                      "Behavior.Ecard"
                    )} (${t("Behavior.Optional")})`}
                  />
              
              </div>
              {eCardCategories && eCardCategories.length > 0 && 
              <div className="Ecard-relative-dropdown">
                  <Dropdown
                  className="Ecard-selected_border"
                    items={EcardCategoryLists()}
                    placeholder={t("Behavior.EcardCategory")}
                    onChange={(e, data) => onEcardCategoryChange(e, data)}
                    value={
                      selectedEcardCategory
                        ? selectedEcardCategory?.name
                        : state?.eCardCategories?.eCardCategories
                    }
                  />
              </div>        
              }
                  {imageValid && (
                          <Alert
                            danger
                            content={
                              <>
                                <TextContent
                                  content={`${t("Behavior.Upload")} ${t(
                                    "Behavior.Jpg"
                                  )}, ${t("Behavior.Png")}: ${t(
                                    "Behavior.Maximumsize"
                                  )} ${state?.PromotionList?.imageUploadSize} ${t(
                                    "Behavior.Mb"
                                  )} , `}
                                />
                                <TextContent
                                  content={` ${t("Behavior.MpFour")}, ${t(
                                    "Behavior.Mov"
                                  )}: ${t("Behavior.Maximumsize")}: ${state?.PromotionList?.videoUploadSize
                                    } ${t("Behavior.Mb")}`}
                                  Maximumsize
                                />
                                {state?.PromotionList?.gifUploadSize &&
                                  <TextContent
                                  content={` ${t("Behavior.Gif")}: ${t(
                                    "Behavior.Maximumsize"
                                  )} ${state?.PromotionList?.gifUploadSize} ${t("Behavior.Mb")}`}
                                />}
                              </>
                            }
                            onVisibleChange={() => {
                              setImageValidator(!imageValid);
                            }}
                            dismissible
                            visible={imageValid}
                            dismissAction={{
                              "aria-label": "close",
                            }}
                            className="notificationMEssage"
  />
)}
              {filTypes && (
                <Alert
                  danger
                  content={
                    <>
                      <TextContent
                        content={`${t("Behavior.Upload")} ${t(
                          "Behavior.Jpg"
                        )}, ${t("Behavior.Png")}, ${t("Behavior.Gif")}: ${t(
                          "Behavior.Maximumsize"
                        )} ${state?.PromotionList?.imageUploadSize} ${t(
                          "Behavior.Mb"
                        )} , `}
                      />
                      <TextContent
                        content={`${t("Behavior.MpFour")}, ${t(
                          "Behavior.Mov"
                        )}: ${t("Behavior.Maximumsize")}: ${state?.PromotionList?.videoUploadSize
                          } ${t("Behavior.Mb")}`}
                      />
                    </>
                  }
                  onVisibleChange={() => {
                    setUnSupportedfileType(!filTypes);
                  }}
                  dismissible
                  visible={filTypes}
                  dismissAction={{
                    "aria-label": "close",
                  }}
                  className="notificationMEssage"
                />
              )}
              {!useEcard && (
                <div className="Ecard_Wraper_list">
                  <Dropzone
                    onDrop={handleDrop}
                    accept={`image/png,image/jpeg,image/gif,video/mp4,video/quicktime,.heic,.heif`}
                    disabled={loading}
                  >
                    {({ getRootProps, getInputProps }) => (
                      <div className="ecardWrapper">
                        {state?.promotion?.allowYourOwnCard && (
                          <div {...getRootProps({ className: "dropzone" })}>
                             <Button
                              icon={<Image src={Upload} />}
                              text
                              style={{ paddingTop: "15px" }}
                              iconOnly
                              title="Create"
                              className="mg-t-5"
                            />

                            <input {...getInputProps()} />
                            <p className="light-blue-text">
                              {t("Behavior.Upload")}
                            </p>
                            {loading && (
                              <LoaderExample
                                label={
                                  uploadProgress === 0
                                    ? ""
                                    : `${uploadProgress} %`
                                }
                              />
                            )}
                          </div>
                        )}

                        {state?.promotion?.ecardActive &&
                          listingImage(eCardsList)}
                      </div>
                    )}
                  </Dropzone>
                  {/* <Grid content={listingImage(eCardsList)} /> */}
                </div>
              )}
              {useEcard &&
                (_.size(customImageVideo) > 0 ? (
                  <div>
                    <div style={{ position: "relative" }}>
                      <button
                        type="submit"
                        className="closeIcon AClass"
                        onClick={() => {
                          setEcard(!useEcard);
                          setFileNames({});
                          dispatch(saveCustomImageInfo({}));
                          setLoading(false);
                        }}
                      >
                        <span>&times;</span>
                      </button>
                      <Image
                        src={
                          _.size(customImageVideo["videoUrl"]) > 0
                            ? customImageVideo["videoUrl"]
                            : customImageVideo["imageUrl"]
                        }
                        height="194"
                        width="194"
                      />
                    </div>
                  </div>
                ) : (
                  <div>
                    <div style={{ position: "relative" }}>
                      <button
                        type="submit"
                        className="closeIcon AClass"
                        onClick={() => {
                          setEcard(!useEcard);
                          setSelectedimage({});
                        }}
                      >
                        <span>&times;</span>
                      </button>
                      <Image
                        src={
                          selectedImage["smallImage"]
                            ? selectedImage["smallImage"]
                            : state?.behaviour?.image?.smallImage
                        }
                        height="194"
                        width="194"
                      />
                    </div>
                  </div>
                ))}
                </div>
              )}
            </div>
          </div>
        ) : (
          <div>
            {selectedImage && (
              <div>
                {loader ? (
                  <div className="align-center">
                    <LoaderExample />
                  </div>
                ) : (
                  <Image
                    src={selectedImage["largeImage"]}
                    className="center"
                    height="358"
                    width="358"
                  />
                )}
                {!loader && (
                  <Flex space="evenly" className="mg-t-5 mg-b-5">
                    <Flex gap="gap.large">
                      <Button
                        content={t("Behavior.Cancel")}
                        title={t("Behavior.Cancel")}
                        size="medium"
                        onClick={(e) => {
                          setshowBigImage(!showImage);
                          setSelectedimage({});
                        }}
                      />
                      <Flex gap="gap.smaller">
                        <Button
                          primary
                          size="medium"
                          content={t("Behavior.UseEcard")}
                          onClick={(e) => {
                            setshowBigImage(!showImage);
                            setEcard(!useEcard);
                          }}
                        />
                      </Flex>
                    </Flex>
                  </Flex>
                )}
              </div>
            )}
          </div>
        )}
        {!showImage ?
          <>
          { (state.promotion.copyManagerActive || state?.promotion?.copyMeActive || state.promotion.copyOthersActive) &&  
            <div className="copyother_section mg-r-5 mg-l-5 pd-bt-100p">
              <TextContent
                className="bit_text_18 bit_text_bold"
                content={t("Behavior.SendCopyHeader")}
              />
              {state.promotion.copyManagerActive ?
                <Checkbox
                  className="copyManager"
                  disabled={state?.promotion?.copyManagerAlways}
                  label={
                    <TextContent
                      content={t("Behavior.SendCopyManagerText")}
                      weight="semibold"
                    />
                  }
                  onClick={onSetManager}
                  checked={manager}
                /> : null}
              {state?.promotion?.copyMeActive ?

                <Checkbox
                  className="copyMe"
                  label={
                    <TextContent
                      content={t("Behavior.SendCopytoMeText")}
                      weight="semibold"
                    />
                  }
                  onClick={onSetMe}
                  checked={me}
                /> : null}
              {state.promotion.copyOthersActive ?
                <TextContent
                  className="send_copy_text bit_text_bold" 
                  content={t("Behavior.SendCopyOther")}
                /> : null}
              {state.promotion.copyOthersActive ?
                <img src={copysearch} className="copy-img" /> : null}
              {state.promotion.copyOthersActive ?
                <input type="text"
                  style={{
                    backgroundColor: "white", border: "1px solid",
                    height: "15px", padding: "15px",
                    borderRadius: "2px", marginTop: "-25px"
                  }}
                  placeholder={t("Behavior.SendCopyOthersPlaceHolder")}
                  onChange={(e) => onFindChange(e)}
                  onClick={copysearchClick}
                  value={findSomeValue}
                /> : null}
              {state.promotion.copyOthersActive ?
                <TextContent
                  content={t("Behavior.sendingCopiesTo")}
                /> : null}
              {copyothersUser.map((val) => (
                <div className="copyotherUser" ref={copyOthersRef}>
                  <Avatar image={val?.avatarUrl ? val?.avatarUrl : ""} name={val.text} className="copy-avatar" />
                  <div style={{ marginRight: "auto" }}>
                    <TextContent className="bit_text_17 paxName" content={val.text} /><br />
                    <TextContent className="bit_text_14 paxDetail" content={val?.email} />
                  </div>
                  <button className="removebtn" onClick={() => removeCopyOthers(val)}>{t("Behavior.Remove")}</button>
                </div>))}
              {copyOthersEmailError ?
                <TextContent
                  content={t("Behavior.SendCopyEMAIL_ERROR")}
                  color={"red"}
                /> : null
              }
              {state.promotion.copyOthersActive ?
                <TextArea
                  fluid
                  style={{ backgroundColor: "white", border: "1px solid", height: "56px" }}
                  placeholder={t("Behavior.OthersEmail")}
                  onChange={(e, data) => onOtherEmailChange(e, data)}
                  value={copyOthersEmailDetails ? copyOthersEmailDetails : ''}
                /> : null}
              {state.promotion.copyOthersActive ?
                <TextContent
                  content={t("Behavior.SendCopyOthersBottomText")}
                  className="colorGrey"
                /> : null}
            </div>
            }
            <div className="footer">
              <Flex space="between">
                <Button
                  icon={<ChevronStartIcon size="large" />}
                  iconOnly
                  tinted
                  title={t("Behavior.Back")}
                  content={t("Behavior.Back")}
                  className="mg-l-5 bit-pad-10"
                  onClick={goBack}
                  style={{ border: "1px #6264a7 solid" }}
                  size="medium"
                />
                <Flex gap="gap.smaller" className="mg-r-5">
                  <Button
                    primary
                    size="medium"
                    title={t("Behavior.Review")}
                    content={t("Behavior.Review")}
                    onClick={gotoReviewSubmit}
                    disabled={
                      (_.size(seletedBehaviour) > 0 ||
                        !state?.promotion?.behaviorRequired) &&
                        textAreaDetails.length > 0
                        ? false
                        : true
                    }
                  />
                </Flex>
              </Flex>
            </div>
          </>
          : null}
      </Provider>
    </motion.div>
  );
};
